module.exports = __webpack_public_path__ + "static/img/159382659.4340f394.png";